module.exports = __webpack_public_path__ + "img/arrow-header.c62fc8ef.svg";